<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="handleNodeClick" :type="1" />
    </section>

    <section class="dp-right" v-loading="loading">
      <div class="links-scroll">
      <div class="header-info">
        <el-alert title="大屏汇总管理" type="info" description="选中左侧学校以获取该校所有大屏地址。部分大屏（如作业公示）需要选择具体班级。"
          style="margin-bottom: 20px" show-icon :closable="false">
        </el-alert>
        <div v-if="currentPath" class="current-school">
          <span>当前所在：</span>
          <el-tag size="medium">{{ currentDepartmentName }}</el-tag>
        </div>
      </div>

      <div class="card-grid">
        <!-- 固定大屏 -->
        <el-card v-for="item in staticScreens" :key="item.name" class="screen-card" shadow="never">
          <div slot="header" class="card-header">
            <div class="title-with-icon">
              <i :class="[item.icon, 'main-icon']" :style="{ color: item.color }"></i>
              <span class="screen-name">{{ item.name }}</span>
            </div>
            <div class="header-right">
              <el-link type="primary" :underline="false" icon="el-icon-position" class="preview-link"
                @click="onStaticPreview(item)">预览</el-link>
              <el-tag size="mini" type="success">固定</el-tag>
            </div>
          </div>
          <div class="card-content">
            <div class="instance-mini-card">
              <div class="field-row">
                <span class="label">访问链接:</span>
                <div class="link-copy-row flex-input">
                  <el-input size="mini" :value="getStaticUrl(item)" readonly class="link-copy-row__input" />
                  <button type="button" class="link-copy-row__btn" @click="onStaticCopy(item)">
                    <i class="el-icon-document-copy"></i>复制
                  </button>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 宿舍大屏参数弹窗：楼栋/日期均可不选 -->
        <el-dialog
          title="宿舍大屏链接"
          :visible.sync="dormDialogVisible"
          width="460px"
          append-to-body
        >
          <el-form label-width="72px" size="small">
            <el-form-item label="楼栋">
              <el-select
                v-model="dormDialog.buildingId"
                clearable
                filterable
                placeholder="不选则按默认首栋，页内可切换"
                style="width: 100%"
              >
                <el-option
                  v-for="b in dormBuildings"
                  :key="b.value"
                  :label="b.label"
                  :value="b.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="日期">
              <el-date-picker
                v-model="dormDialog.date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="不选则为当天实时"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-form>
          <div class="dorm-dialog-url">{{ dormPreviewUrl || '请先选择左侧学校' }}</div>
          <span slot="footer">
            <el-button size="small" @click="dormDialogVisible = false">取消</el-button>
            <el-button size="small" type="primary" :disabled="!dormPreviewUrl" @click="confirmDormDialog">
              {{ dormDialog.action === 'copy' ? '复制链接' : '打开预览' }}
            </el-button>
          </span>
        </el-dialog>

        <!-- 作业公示 (带有班级选择逻辑) -->
        <el-card class="screen-card homework-card" shadow="never" v-if="currentSchId">
          <div slot="header" class="card-header">
            <div class="title-with-icon">
              <i class="el-icon-notebook-2 main-icon" style="color: #a855f7"></i>
              <span class="screen-name">作业公示</span>
            </div>
            <div class="header-right">
              <el-link type="primary" :underline="false" icon="el-icon-position" class="preview-link"
                :disabled="!homeworkUrl" @click="openUrl(homeworkUrl)">预览</el-link>
              <el-tag size="mini" type="warning">班级</el-tag>
            </div>
          </div>
          <div class="card-content">
            <div class="instance-mini-card">
              <div class="field-row">
                <span class="label">选择班级:</span>
                <el-select v-model="selectedClassId" placeholder="请搜索班级" filterable size="mini" class="flex-input"
                  @change="updateHomeworkUrl">
                  <el-option v-for="item in classOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </div>
              <div class="field-row" style="margin-top: 12px;">
                <span class="label">访问链接:</span>
                <div class="link-copy-row flex-input">
                  <el-input size="mini" :value="homeworkUrl" readonly placeholder="请先选择班级"
                    class="link-copy-row__input" />
                  <button type="button" class="link-copy-row__btn" :disabled="!homeworkUrl"
                    @click="copyUrl(homeworkUrl)">
                    <i class="el-icon-document-copy"></i>复制
                  </button>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 放学大屏 (美化后的网格布局) -->
        <el-card class="screen-card dismissal-card" shadow="never" v-if="dismissalScreens.length > 0">
          <div slot="header" class="card-header">
            <div class="title-with-icon">
              <i class="el-icon-monitor main-icon" style="color: #2563eb"></i>
              <span class="screen-name">放学大屏汇总</span>
            </div>
            <el-tag size="mini" effect="dark" type="primary">屏幕数量: {{ dismissalScreens.length }}</el-tag>
          </div>
          <div class="card-content dismissal-grid">
            <div v-for="item in dismissalScreens" :key="item.Id" class="instance-mini-card">
              <div class="instance-top">
                <span class="instance-name"><i class="el-icon-location-outline"></i> {{ item.ScreenName }}</span>
                <el-link type="primary" :underline="false" icon="el-icon-position"
                  @click="openUrl(getDismissalUrl(item.ScreenCode))">预览</el-link>
              </div>
              <div class="instance-bottom">
                <div class="link-copy-row">
                  <el-input size="mini" :value="getDismissalUrl(item.ScreenCode)" readonly class="link-copy-row__input" />
                  <button type="button" class="link-copy-row__btn"
                    @click="copyUrl(getDismissalUrl(item.ScreenCode))">
                    <i class="el-icon-document-copy"></i>复制链接
                  </button>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 无结果展示 -->
        <div v-if="!currentSchId" class="empty-holder">
          <el-empty description="请选择左侧学校/机构以获取大屏地址列表"></el-empty>
        </div>
      </div>
      </div>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "@/components/DepartmentPane.vue";
import { getScreenList, parseScreenListResponse } from "@/api/dismissal";
import { getSubDepartmentTree } from '../../api/modules/department';
import { getBuildingsListPage } from '../../api/modules/dormitory';

export default {
  name: "BigScreenLinks",
  components: { DepartmentPane },
  data() {
    return {
      /** 当前站点源；SPA 子路径由 uiBasePath（BASE_URL）拼接，兼容 /ui 与根路径部署 */
      baseUrl: window.location.origin,
      loading: false,
      currentSchId: "",
      currentDepartmentName: "",
      classOptions: [],
      selectedClassId: "",
      dismissalScreens: [],
      homeworkUrl: "",
      dormDialogVisible: false,
      dormBuildings: [],
      dormDialog: {
        action: 'preview',
        buildingId: '',
        date: '',
      },
      staticScreens: [
        { name: "考勤大屏", path: "/AttenBigScreen", param: "departmentId", icon: "el-icon-time", color: "#2563eb" },
        { name: "宿舍大屏", path: "/static/dorm-screen/index.html", param: "departmentId", icon: "el-icon-house", color: "#67C23A", needBuilding: true },
        { name: "请假大屏", path: "/LeaveBigScreen", param: "departmentId", icon: "el-icon-suitcase", color: "#E6A23C" },
        { name: "请假离校大屏", path: "/LeaveOutBigScreen", param: "departmentId", icon: "el-icon-circle-close", color: "#F56C6C" },
        { name: "学校大屏", path: "/SchoolInfoScreen", param: "departmentId", icon: "el-icon-school", color: "#909399" },
        { name: "德育大屏", path: "/MoralEducationBigScreen", param: "departmentId", icon: "el-icon-medal", color: "#00bcd4" },
        { name: "积分大屏", path: "/MoralPointBigScreen", param: "departmentId", icon: "el-icon-coin", color: "#ffb347" },
        { name: "五育大屏", path: "/ZheshangFiveEducationScreen", param: "departmentId", icon: "el-icon-data-analysis", color: "#7c3aed" },
        { name: "学生画像", path: "/ZheshangStudentPortraitScreen", param: "departmentId", icon: "el-icon-user", color: "#ec4899" }
      ]
    };
  },
  computed: {
    currentPath() {
      return this.currentSchId;
    },
    /**
     * 前端部署前缀：build:api 为 /ui；正式独立站点为 ''。
     * 创建于 2026-08-12
     */
    uiBasePath() {
      const raw = (process.env.BASE_URL || "/").replace(/\/+$/, "");
      return raw === "/" ? "" : raw;
    },
    /** 宿舍大屏弹窗实时预览链接（独立静态页，无后台壳） */
    dormPreviewUrl() {
      if (!this.currentSchId) return '';
      let q = `departmentId=${this.currentSchId}`;
      if (this.dormDialog.buildingId) q += `&buildingId=${this.dormDialog.buildingId}`;
      if (this.dormDialog.date) q += `&date=${this.dormDialog.date}`;
      const api = (process.env.VUE_APP_BASE_API || '').replace(/\/+$/, '');
      if (api && api !== window.location.origin) {
        q += `&apiBase=${encodeURIComponent(api)}`;
      }
      return this.buildFrontUrl('/static/dorm-screen/index.html', q);
    }
  },
  methods: {
    handleNodeClick(data) {
      if (data.value == "0") {
        this.$message.warning("请选择具体的学校或校区");
        this.resetState();
        return;
      }
      // 切换学校时先清空上一个学校的作业公示选择与链接，避免残留显示
      this.selectedClassId = "";
      this.homeworkUrl = "";
      this.classOptions = [];
      this.dismissalScreens = [];
      this.currentSchId = data.value;
      this.currentDepartmentName = data.label;
      this.fetchData();
    },
    resetState() {
      this.currentSchId = "";
      this.currentDepartmentName = "";
      this.dismissalScreens = [];
      this.classOptions = [];
      this.selectedClassId = "";
      this.homeworkUrl = "";
    },
    async fetchData() {
      if (!this.currentSchId) return;
      this.loading = true;
      try {
        // 1. 获取放学大屏多实例
        const resDismissal = await getScreenList({ schId: this.currentSchId, page: 1, intPageSize: 999 });
        if (resDismissal.data.success) {
          this.dismissalScreens = parseScreenListResponse(resDismissal);
        }

        // 2. 获取学校下的班级列表供作业大屏使用
        const resClasses = await getSubDepartmentTree({ pid: this.currentSchId });
        if (resClasses.data.success) {
          this.classOptions = this.extractClasses(resClasses.data.response);
        }
      } catch (e) {
        console.error("加载数据失败", e);
      } finally {
        this.loading = false;
      }
    },
    extractClasses(nodes) {
      let results = [];
      const traverse = (list) => {
        if (!list) return;
        const items = Array.isArray(list) ? list : [list];
        items.forEach(node => {
          if (node.DeptOrgType === 'class') {
            results.push({ label: node.label, value: node.value });
          }
          if (node.children && node.children.length) {
            traverse(node.children);
          }
        });
      };
      traverse(nodes);
      return results;
    },
    /** 拼前端页面完整地址（含 /ui 前缀）。创建于 2026-08-12 */
    buildFrontUrl(path, query) {
      const p = path.startsWith("/") ? path : `/${path}`;
      const q = query ? (query.startsWith("?") ? query : `?${query}`) : "";
      return `${this.baseUrl}${this.uiBasePath}${p}${q}`;
    },
    getStaticUrl(item) {
      if (!this.currentSchId) return "";
      return this.buildFrontUrl(item.path, `${item.param}=${this.currentSchId}`);
    },
    getDismissalUrl(code) {
      return this.buildFrontUrl("/DismissalBigScreen", `code=${code}`);
    },
    updateHomeworkUrl() {
      if (!this.selectedClassId) {
        this.homeworkUrl = "";
      } else {
        this.homeworkUrl = this.buildFrontUrl("/HomeWorkPage", `id=${this.selectedClassId}`);
      }
    },
    /** 固定大屏预览：宿舍大屏先弹窗选楼栋/日期 */
    onStaticPreview(item) {
      if (item && item.needBuilding) {
        this.openDormDialog('preview');
        return;
      }
      this.openUrl(this.getStaticUrl(item));
    },
    /** 固定大屏复制：宿舍大屏先弹窗选楼栋/日期 */
    onStaticCopy(item) {
      if (item && item.needBuilding) {
        this.openDormDialog('copy');
        return;
      }
      this.copyUrl(this.getStaticUrl(item));
    },
    async openDormDialog(action) {
      if (!this.currentSchId) {
        this.$message.warning('请先选择左侧学校');
        return;
      }
      this.dormDialog.action = action;
      this.dormDialog.buildingId = '';
      this.dormDialog.date = '';
      this.dormDialogVisible = true;
      await this.loadDormBuildings();
    },
    async loadDormBuildings() {
      if (!this.currentSchId) {
        this.dormBuildings = [];
        return;
      }
      try {
        const res = await getBuildingsListPage({
          page: 1,
          intPageSize: 500,
          departmentId: this.currentSchId,
        });
        const data = res && res.data;
        const list =
          (data && data.response && (data.response.data || data.response)) ||
          (data && data.data) ||
          [];
        const arr = Array.isArray(list) ? list : [];
        this.dormBuildings = arr.map((b) => ({
          label: b.Name || b.BuildingName || b.name || ('楼栋' + (b.Id || b.id)),
          value: String(b.Id || b.id || ''),
        })).filter((b) => b.value);
      } catch (e) {
        this.dormBuildings = [];
        console.error('加载宿舍楼栋失败', e);
      }
    },
    confirmDormDialog() {
      const url = this.dormPreviewUrl;
      if (!url) return;
      if (this.dormDialog.action === 'copy') this.copyUrl(url);
      else this.openUrl(url);
      this.dormDialogVisible = false;
    },
    copyUrl(url) {
      if (!url) return;
      const input = document.createElement("input");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("链接已复制");
    },
    openUrl(url) {
      if (!url) return;
      window.open(url, "_blank");
    }
  }
};
</script>

<style lang="stylus" scoped>
  // 应用用户要求的全局间距规范
  >>> .el-card__body
    padding 0 20px 0px 20px

  .header-info
    flex-shrink 0
    margin-bottom 16px
    .current-school
      margin-top 15px
      display flex
      align-items center
      gap 10px
      font-size 14px
      color #475569
      span
        font-weight 600

  .links-scroll
    flex 1 1 auto
    min-height 0
    height 0
    width 100%
    overflow-x hidden
    overflow-y auto
    -webkit-overflow-scrolling touch
    padding-right 4px
    padding-bottom 20px
    box-sizing border-box
    scrollbar-width thin
    scrollbar-color #94a3b8 transparent
    &::-webkit-scrollbar
      width 6px
    &::-webkit-scrollbar-thumb
      background-color #94a3b8
      border-radius 8px
    &::-webkit-scrollbar-track
      background transparent

  .card-grid
    display grid
    grid-template-columns repeat(auto-fill, minmax(360px, 1fr))
    gap 24px
    align-content start

  .screen-card
    border-radius 12px
    transition border-color 0.2s ease, box-shadow 0.2s ease
    border 1px solid #eef2f7
    background #fff
    overflow hidden
    
    >>> .el-card__header
      padding 22px 20px 18px 20px
      border-bottom 1px solid #f1f5f9
      
    &:hover
      border-color #cbd5e1
      box-shadow 0 4px 14px rgba(15, 23, 42, 0.06)

  .link-copy-row
    flex 1
    min-width 0
    display flex
    align-items stretch
    border 1px solid #e2e8f0
    border-radius 6px
    overflow hidden
    background #f8fafc

    &__input
      flex 1
      min-width 0
      >>> .el-input
        width 100%
      >>> .el-input__inner
        height 28px
        line-height 28px
        border none
        border-radius 0
        background transparent
        color #475569
        font-size 12px
        &:hover,
        &:focus
          border none
          box-shadow none

    &__btn
      flex-shrink 0
      display inline-flex
      align-items center
      justify-content center
      gap 4px
      padding 0 14px
      margin 0
      border none
      border-left 1px solid #e2e8f0
      border-radius 0
      background transparent
      color #3b82f6
      font-size 12px
      font-weight 600
      line-height 1
      cursor pointer
      user-select none
      outline none
      -webkit-tap-highlight-color transparent
      transition background 0.15s ease, color 0.15s ease
      &:hover:not(:disabled)
        background #eff6ff
        color #2563eb
      &:active:not(:disabled)
        background #dbeafe
        color #1d4ed8
      &:disabled
        color #94a3b8
        cursor not-allowed
        background #f1f5f9

  .card-header
    display flex
    justify-content space-between
    align-items center
    
    .title-with-icon
      display flex
      align-items center
      gap 12px
      .main-icon
        font-size 22px
        font-weight bold
      .screen-name
        font-weight 800
        color #1e293b
        font-size 16px

    .header-right
      display flex
      align-items center
      gap 20px
      
      .preview-link
        font-size 13px
        font-weight 600

  .card-content
    padding 15px 0 15px 0
    
    .field-row
      display flex
      align-items center
      
      .label
        flex-shrink 0
        width 70px
        font-size 13px
        color #64748b
        margin-bottom 0 // 移除原本的换行间距

      .flex-input
        flex 1

  .dismissal-card
    grid-column 1 / -1
    
    .dismissal-grid
      display flex
      flex-wrap wrap
      gap 16px
      margin-top 10px
      
    .instance-mini-card
      flex 1
      min-width 310px
      max-width 49%
      background linear-gradient(135deg, #ffffff 0%, #f9fbff 100%)
      border 1px solid #e2e8f0
      border-radius 12px
      padding 16px
      transition all 0.3s
      
      &:hover
        border-color #60a5fa
        box-shadow 0 8px 16px rgba(59, 130, 246, 0.08)
        
      .instance-top
        display flex
        justify-content space-between
        align-items center
        margin-bottom 12px
        
        .instance-name
          font-weight 700
          color #334155
          font-size 14px
          i
            color #60a5fa
            margin-right 6px
            
      .instance-bottom
        .link-copy-row
          width 100%

  .empty-holder
    grid-column 1 / -1
    padding-top 50px

  .dorm-dialog-url
    margin-top 8px
    padding 8px 10px
    background #f8fafc
    border 1px solid #e2e8f0
    border-radius 6px
    font-size 12px
    color #475569
    word-break break-all
</style>
